import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { SystemApi } from '@/services/api/api.system';
import { DonationPriceViewModel, SystemMetrics } from '@/types/apiServerContract';
import { PayPalApi } from '@/services/api/api.paypal';

@Module({ namespaced: true, dynamic: true, store, name: 'SystemModule' })
class SystemState extends VuexModule {
	metrics: SystemMetrics | null = null;
	paypalSettings: DonationPriceViewModel | null = null;

	@Mutation
	SetMetrics(metrics: SystemMetrics | null) {
	    this.metrics = Object.freeze(metrics);
	}

	@Action({ rawError: true })
	async GetSystemMetrics() {
	    const metrics = await SystemApi.GetSystemMetrics();
	    this.SetMetrics(Object.freeze(metrics.metrics));
	}

	@Mutation
	HandleDonationSettings(settings: DonationPriceViewModel | null) {
	    this.paypalSettings = Object.freeze(settings);
	}

	@Action({ rawError: true })
	async GetDonationSettings() {
	    const result = await PayPalApi.GetDonationSettings();
	    this.HandleDonationSettings(result);
	}

	@Mutation
	Reset() {
	    this.metrics = null;
	}

	@Action({ rawError: true })
	Clear() {
	    this.Reset();
	}

	@Action({ rawError: true })
	async Init() {}
}

const SystemModule = getModule(SystemState);

export { SystemModule };
